import emailjs from 'emailjs-com';
import { Bounce, toast } from "react-toastify";
import React, { useState, ChangeEvent, FormEvent } from 'react';

import './contact.css';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const serviceId = import.meta.env.VITE_EMAILJS_SERVICE_ID as string;
    const publickKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY as string;
    const templateId = import.meta.env.VITE_EMAILJS_CONTACT_TEMPLATE_ID as string;

    emailjs.send(serviceId, templateId, formData, publickKey)
    .then((response)=>{
      console.log(response)
      setFormData({ name: "", email: "", subject: "", message: "" });
      toast.success("Thank you! You're email has been sent!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    })
    .catch((error)=>{
      console.log(error)
      toast.error("Something went wrong!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    })

  };

  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="text-center mb-5">
              <h3 className="mb-3 fw-semibold">Get In Touch</h3>
              <p className="text-muted mb-4 ff-secondary">
              Feel free to send us a message below. We will do our best to respond as soon as we can.
              </p>
            </div>
          </div>
        </div>
        <div className="row gy-4">
          <div className="col-lg-4">
            <div className="mt-4">
              <h5 className="fs-13 text-muted text-uppercase">Office Address 1:</h5>
              <div className="ff-secondary fw-semibold">4461 Oasys Street, <br />AR 72368</div>
            </div>
            <div className="mt-4">
              <h5 className="fs-13 text-muted text-uppercase">Office Address 2:</h5>
              <div className="ff-secondary fw-semibold">2467 Kalama Street <br />Nairobi, KE</div>
            </div>
            <div className="mt-4">
              <h5 className="fs-13 text-muted text-uppercase">Working Hours:</h5>
              <div className="ff-secondary fw-semibold">9:00am to 6:00pm</div>
            </div>
          </div>
          <div className="col-lg-8">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-4">
                    <label htmlFor="name" className="form-label fs-13">Name</label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      className="form-control bg-light border-light"
                      placeholder="Your name*"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-4">
                    <label htmlFor="email" className="form-label fs-13">Email</label>
                    <input
                      name="email"
                      id="email"
                      type="email"
                      className="form-control bg-light border-light"
                      placeholder="Your email*"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="mb-4">
                    <label htmlFor="subject" className="form-label fs-13">Subject</label>
                    <input
                      type="text"
                      className="form-control bg-light border-light"
                      id="subject"
                      name="subject"
                      placeholder="Your Subject.."
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label fs-13">Message</label>
                    <textarea
                      name="message"
                      id="message"
                      rows={3}
                      className="form-control bg-light border-light"
                      placeholder="Your message..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 text-end">
                  <input
                    type="submit"
                    id="submit"
                    name="send"
                    className="submitBnt btn btn-primary"
                    value="Send Message"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
